<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import _groupBy from 'lodash/groupBy'
import _filter from 'lodash/filter'
import _find from 'lodash/find'

import cityService from 'api/city'
import inventoryService from 'api/inventory'
import dateUtils from 'utils/dateUtils'
import InventoryListItem from 'components/InventoryListItem'
import SelectedInventory from 'components/SelectedInventory'
import * as mutationTypes from 'store/mutationTypes'
import venueService from 'api/venue'
import store from 'store'
import eventBus from 'lib/eventBus'

export default {
  name: 'membership-perks-inventory',
  components: {
    Datepicker,
    InventoryListItem,
    SelectedInventory,
  },
  props: {},
  computed: {
    ...mapState({
      date: (state) => state.date.current,
      user: (state) => state.user.current,
    }),
    affiliate() {
      return this.$store.state.membership.currentAffiliate
    },
    utcDate() {
      return this.date ? dateUtils.toUTCDateWithoutTime(this.date) : ''
    },
    inventoryGroupedByVenue() {
      const inventory = this.affiliate
        ? _filter(this.inventory, (inv) => {
            return !(this.affiliate.membershipVenues || []).includes(inv.venue.id)
          })
        : this.inventory

      const groups = _groupBy(inventory, 'venue._id')

      return Object.keys(groups).map((key) => {
        return {
          inventory: groups[key],
          venue: groups[key][0].venue,
        }
      })
    },
    filteredCities() {
      if (!this.affiliate || !this.affiliate.membershipCities || !this.affiliate.membershipCities.length) {
        return this.cities
      }

      return _filter(this.cities, (city) => {
        return (this.affiliate.membershipCities || []).includes(city.id)
      })
    },
    currentCity() {
      return _find(this.cities, {
        id: this.currentCityId,
      })
    },
    currentCityImage() {
      if (!this.currentCity) return ''

      const image =
        this.currentCity && this.currentCity.images && this.currentCity.images.length
          ? _find(this.currentCity.images, {
              primary: true,
            })
          : {}

      return image.filename
    },
  },
  data() {
    return {
      loading: false,
      inventoryLoading: false,
      cities: null,
      currentCityId: null,
      inventory: null,
      selectedInventory: null,
      selectedInventoryQuantity: 1,
      datePickerDisabledOptions: {
        to: moment.utc().subtract(1, 'day').toDate(),
      },
      showCheckout: false,
    }
  },
  methods: {
    getCities() {
      return cityService.list().then((result) => {
        this.cities = result.data
      })
    },
    getVenueImage(venue) {
      if (!venue || !venue.primaryImage) return ''

      return venue.primaryImage.filename
    },
    getVenueAddress(location) {
      if (!location || !location.address) return ''

      let address = ''

      address += location.address.address
      address += `<br> ${location.address.city}`
      address += `, ${location.address.state}`

      return address
    },
    getInventoryByCityId() {
      this.inventoryLoading = true

      return inventoryService
        .listByCityId(this.currentCityId, {
          dateStart: dateUtils.toUTCTimestampWithoutTime(this.date),
          dateEnd: dateUtils.toUTCTimestampWithoutTime(this.date),
          membershipLevelMin: 50,
          fields: 'venue(name, images, location, visibility)',
        })
        .then((result) => {
          this.inventoryLoading = false

          this.inventory = _filter(result.data, (inv) => {
            return inv.venue.visibility >= 20
          })
        })
    },
    onCityChanged() {
      if (!this.currentCityId) return null

      return this.getInventoryByCityId()
    },
    onDatepickerSelected(newDate) {
      const date = dateUtils.toUTCMomentWithoutTime(newDate)

      this.$store.dispatch('setCurrentDate', date)
    },
    onDatepickerOpened() {
      eventBus.$emit('updated', {
        minHeight: 800,
      })
    },
    selectInventory(inventory) {
      venueService.getById(inventory.venue._id).then((result) => {
        this.selectedInventory = inventory

        this.$store.dispatch('setCurrentVenue', result.data)
      })
    },
    onCheckout() {
      if (!this.$refs.selectedInventory.isValid()) {
        return
      }

      Promise.all([
        this.$store.dispatch('addCartItem', {
          inventoryId: this.selectedInventory.id,
          quantity: this.selectedInventoryQuantity,
        }),
        this.$store.dispatch('startCheckout'),
      ]).then(() => {
        this.$router.push({
          name: 'MembershipPerksCheckout',
          query: {
            cityId: this.currentCityId,
            inventoryId: this.selectedInventory.id,
            inventoryQuantity: this.selectedInventoryQuantity,
          },
        })
      })
    },
    onModalBodyClicked(event) {
      if (!this.$refs.datePicker) return

      if (this.$refs.datePicker.$el !== event.target && !this.$refs.datePicker.$el.contains(event.target)) {
        this.$refs.datePicker.close()
      }
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SET_CURRENT_DATE) {
        this.getInventoryByCityId()
      }
    },
  },
  mounted() {
    this.loading = true

    this.getCities().then(() => {
      this.loading = false

      const preferredCity = this.user.location && this.user.location.preferred ? this.user.location.preferred._id : null

      this.currentCityId = this.$route.query.cityId || preferredCity
      this.currentCityId = !this.currentCity ? this.filteredCities[0].id : this.currentCityId

      return this.getInventoryByCityId()
    })

    this.storeUnsubscribe = store.subscribe(this.onMutation)

    const modalBodyEl = document.querySelectorAll('.modal-body')[0]

    if (modalBodyEl) {
      modalBodyEl.addEventListener('click', this.onModalBodyClicked)
    }
  },
  updated() {
    eventBus.$emit('updated')
  },
  destroyed() {
    this.storeUnsubscribe()

    const modalBodyEl = document.querySelectorAll('.modal-body')[0]

    if (modalBodyEl) {
      modalBodyEl.removeEventListener('click', this.onModalBodyClicked)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipPerksInventory/index.vue